// TESTIMONIALS *****************************************        
                             

// ---- INIT ----
let ptsGuard = false;
let ptsIndex = 0;
const ptsTotalSlides = $('.prod-testimonial').length;


// ---- CENTER SLIDE ----
function centerSlide($slide) {
    const h = $slide.outerHeight();
    $slide.css('top', 'calc(50% - ' + (h / 2) + 'px)');
}


// ---- ANIMATE LOGOS ----
function animatePTSLogos() {
    $('.pts-logo').each(function() {
        const current = Number($(this).data('rotation')) || 0;
        const amount = Math.random() > 0.5 ? 50 : 25;
        const direction = Math.random() > 0.5 ? 1 : -1;
        const next = current + (amount * direction);
        $(this).data('rotation', next);
        $(this).css('transform', 'rotate(' + next + 'deg)');
    });
}


// ---- NAV ----
function ptsNav(direction) {
    if (ptsGuard) return;
    ptsGuard = true;
    setTimeout(() => { ptsGuard = false; }, 1000);
    const $slides = $('.prod-testimonial');
    const $current = $slides.filter('.active');
    ptsIndex = direction === 'next'
        ? (ptsIndex === ptsTotalSlides - 1 ? 0 : ptsIndex + 1)
        : (ptsIndex === 0 ? ptsTotalSlides - 1 : ptsIndex - 1);
    const $next = $slides.eq(ptsIndex);
    centerSlide($next);
    animatePTSLogos(); 
    $current.removeClass('active');
    setTimeout(() => { $next.addClass('active'); }, 500);
}


// ---- TRIGGERS ----
$('#PTS-prev').on('click', function() { ptsNav('prev'); });
$('#PTS-next').on('click', function() { ptsNav('next'); });

    
// ---- CENTER FIRST SLIDE ----
centerSlide($('.prod-testimonial.active'));




    







// INCLUDE GEAR *****************************************    


// click handler ***
$('#IncludeGear h5').on('click', function () {
    var $this = $(this);
    if ($this.hasClass('active')) return; 
    $('#IncludeGear h5.active').removeClass('active');
    $this.addClass('active');
    $('#BuyClubTeamSeason').attr('data-gear-included', $this.hasClass('yes') ? 'true' : 'false');
});
 










